import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  useEffect(() => {
    const h = (e) => { e.preventDefault(); if (!localStorage.getItem("n365-install-dismissed")) setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  if (!evt) return null;
  const dismiss = () => { localStorage.setItem("n365-install-dismissed", "1"); setEvt(null); };
  return (
    <div data-testid="pwa-install-banner" className="rise fixed inset-x-3 bottom-20 z-50 flex items-center gap-3 rounded-2xl bg-foreground p-3 pl-4 text-background shadow-2xl lg:bottom-6 lg:left-auto lg:right-6 lg:w-96">
      <img src="/icon.svg" alt="" className="h-10 w-10 rounded-xl" />
      <div className="flex-1 text-sm"><b>Instalar Notícia 365</b><p className="opacity-70 text-xs">Acesso rápido, como uma app.</p></div>
      <button data-testid="pwa-install-btn" onClick={async () => { evt.prompt(); await evt.userChoice; setEvt(null); }} className="flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-bold text-white"><Download size={14} />Instalar</button>
      <button data-testid="pwa-dismiss-btn" onClick={dismiss} aria-label="Fechar" className="opacity-60 hover:opacity-100"><X size={18} /></button>
    </div>
  );
}
